<template lang='pug'>
  include ./../../mixins
  +b.DIV
    +b.mdi.mdi-close.fs_xl.color_green.close-modal--video.cursor-pointer(@click.prevent="toggleHandler")
  
    +b.video-modal.IFRAME(:src='src' frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen height='100%')
    
  </div>
</template>

<script>
  export default {
    props: {
      src: {
        type: String,
        required: true
      },

    },
    methods: {
      toggleHandler() {
        this.$modal.hide("video")
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/Modal/VideoModal.vue